import { LocalDate } from "@js-joda/core";
import { CashflowItems } from "./types-v2";

export const jUserId = "a8c7d483-5c1d-4a8d-8bac-7fb23f721260";
export const hUserId = "211b1b00-7c16-4b93-8473-e2c7a7980f0d";

const gbpToPence = (value: number) => Math.round(value * 100);

export const dataV2: CashflowItems = [
  {
    id: "974ebe6e-ad2d-4aba-9bc0-b2cb71215258",
    type: "INCOME_ITEM",
    description: "J salary",
    amountPence: gbpToPence(84_000),
    taxable: false,
    userId: jUserId,
    recurrence: {
      kind: "every-x-months-last-working-day",
      align: "last-working-day",
      interval: 1,
      recurrenceAnchorDate: LocalDate.parse("2024-01-16"), // make sure user puts employment start date?
    },
  },
  {
    id: "f9fe1ce9-b4b4-41a7-bff0-3a990a687d07",
    type: "INCOME_ITEM",
    description: "H Salary",
    amountPence: gbpToPence(90_000),
    taxable: true,
    userId: hUserId,
    recurrence: {
      kind: "every-x-months-last-working-day",
      align: "last-working-day",
      interval: 1,
      recurrenceAnchorDate: LocalDate.parse("2024-01-16"),
    },
  },
  {
    id: "fab84530-3477-4f40-914c-80451700a74e",
    type: "OUTGOINGS_ITEM",
    description: "Car loan",
    amountPence: gbpToPence(506.26),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "af0f00b9-f760-4635-bd2f-a6d2e0ed4d88",
    type: "OUTGOINGS_ITEM",
    description: "Mortgage",
    amountPence: gbpToPence(1256.33),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "a4a1e9d1-a13a-4af8-94c7-786ecca79673",
    type: "OUTGOINGS_ITEM",
    description: "Council tax",
    amountPence: gbpToPence(230),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 2,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "11e5a396-8eef-4eb0-97c6-e1d7d530318f",
    type: "OUTGOINGS_ITEM",
    description: "Energy bills",
    amountPence: gbpToPence(150),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 2,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "cdff286e-7c11-468d-8ab3-03c240e6e987",
    type: "OUTGOINGS_ITEM",
    description: "Car insurance",
    amountPence: gbpToPence(526),
    recurrence: {
      kind: "every-x-years",
      interval: 1,
      month: 8,
      dayOfMonth: 5,
      recurrenceAnchorDate: LocalDate.parse("2024-08-05"),
    },
  },
  {
    id: "4d674ff6-7a1e-4873-81c1-b81df67b3c43",
    type: "OUTGOINGS_ITEM",
    description: "House insurance",
    amountPence: gbpToPence(228),
    recurrence: {
      kind: "every-x-years",
      interval: 1,
      month: 8,
      dayOfMonth: 6,
      recurrenceAnchorDate: LocalDate.parse("2024-08-06"),
    },
  },
  {
    id: "de7e163a-a3dd-4a2c-85d1-46f2e70eea9b",
    type: "OUTGOINGS_ITEM",
    description: "BT (Internet, Mobiles, NowTV)",
    amountPence: gbpToPence(38.88),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 15,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "ac6b543f-b0d9-4a82-9b85-e3a7b2443b11",
    type: "OUTGOINGS_ITEM",
    description: "Spotify",
    amountPence: gbpToPence(19.99),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "0b5c62ad-b5f2-4ff7-8e03-3a57d8cc4a87",
    type: "OUTGOINGS_ITEM",
    description: "Water bills",
    amountPence: gbpToPence(57),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 19,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "953aa6ea-a775-4900-8728-1a5fb063d5ae",
    type: "OUTGOINGS_ITEM",
    description: "Travel",
    amountPence: gbpToPence(50),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "429b9b52-429d-4334-ba29-92530ebb9430",
    type: "OUTGOINGS_ITEM",
    description: "Groceries",
    amountPence: gbpToPence(150),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "be8e63a3-b92b-42c1-aa7d-5f6128250348",
    type: "OUTGOINGS_ITEM",
    description: "Dog food",
    amountPence: gbpToPence(53),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "c1027f39-269e-4acf-8477-0a2c58fa0d7f",
    type: "OUTGOINGS_ITEM",
    description: "Dog insurance (Agria + Vets)",
    amountPence: gbpToPence(54.29),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 5,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "73ef68cc-2b7c-47a3-9d99-c58cba98d752",
    type: "OUTGOINGS_ITEM",
    description: "Travel insurance",
    amountPence: gbpToPence(150),
    recurrence: {
      kind: "every-x-years",
      interval: 1,
      month: 8,
      dayOfMonth: 22,
      recurrenceAnchorDate: LocalDate.parse("2025-08-22"),
    },
  },
  {
    id: "b225f73b-fe9e-4129-937c-58fdcdce7f25",
    type: "OUTGOINGS_ITEM",
    description: "TV license",
    amountPence: gbpToPence(15),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 2,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "f9b8287c-f900-492c-b52c-23e97f0581a5",
    type: "OUTGOINGS_ITEM",
    description: "Holly gym",
    amountPence: gbpToPence(75),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 2,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "a9fe9e3b-83e3-4019-800b-797b59e0795d",
    type: "OUTGOINGS_ITEM",
    description: "Holly contact lenses",
    amountPence: gbpToPence(30),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 30,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "b69914f3-c767-4212-8301-6e045a0f5dd3",
    type: "OUTGOINGS_ITEM",
    description: "J Gym",
    amountPence: gbpToPence(35),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "696d8f81-12f3-455f-84c3-20f6b2c07cbe",
    type: "OUTGOINGS_ITEM",
    description: "J PT",
    amountPence: gbpToPence(400),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 3,
      dayOfMonth: 24,
      recurrenceAnchorDate: LocalDate.parse("2025-11-24"),
    },
  },
  {
    id: "ed7e9967-7cf6-45f6-bf7e-f8215e8654e8",
    type: "OUTGOINGS_ITEM",
    description: "Coffees",
    amountPence: gbpToPence(10),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "80c16f42-842f-4b0d-bb74-f9186b780670",
    type: "OUTGOINGS_ITEM",
    description: "Shopping",
    amountPence: gbpToPence(125),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "49394be3-6689-49f4-b267-87fba64c9296",
    type: "OUTGOINGS_ITEM",
    description: "Social spend",
    amountPence: gbpToPence(100),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "9fd33297-a115-491d-8d7d-0ad5554eef72",
    type: "OUTGOINGS_ITEM",
    description: "DIY / Maintenance",
    amountPence: gbpToPence(25),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "ffa49a3b-b47b-4ff4-b506-79c77b9fe3f1",
    type: "OUTGOINGS_ITEM",
    description: "Car maintenance + petrol",
    amountPence: gbpToPence(160),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "3281b9c9-0986-4d94-995a-f17e034da8f6",
    type: "OUTGOINGS_ITEM",
    description: "Physio + Ostep",
    amountPence: gbpToPence(100),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "6b88ede5-b677-4b1d-b751-d501d48cd6c7",
    type: "OUTGOINGS_ITEM",
    description: "Swimming",
    amountPence: gbpToPence(30),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 2,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "b00d5a3d-7933-45a9-8de2-14b6deeb9310",
    type: "OUTGOINGS_ITEM",
    description: "AWS",
    amountPence: gbpToPence(5),
    recurrence: {
      kind: "every-x-months",
      align: "fixed-day",
      interval: 1,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-01-16"),
    },
  },
  {
    id: "cc1b9710-600f-4c7e-95d2-d5d90c15224b",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW1",
    amountPence: gbpToPence(11027),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-04-09")],
    },
  },
  {
    id: "bb13c0a0-2f15-4270-8ea5-abfae85999fe",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW2",
    amountPence: gbpToPence(9145),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-04-16")],
    },
  },
  {
    id: "7a70d7f4-b703-4c92-b72e-79f10504eae2",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW3",
    amountPence: gbpToPence(9145),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-04-23")],
    },
  },
  {
    id: "b6c733cc-605e-4fa6-9c43-d45f7cd7afa2",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW4",
    amountPence: gbpToPence(9145),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-04-30")],
    },
  },
  {
    id: "c27c6aab-c8ff-46ad-8469-8c7de5dda238",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW5",
    amountPence: gbpToPence(9145),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-05-07")],
    },
  },
  {
    id: "fd4a3885-07ca-46c9-a9cf-bbeb3dfd0a34",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW6",
    amountPence: gbpToPence(9145),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-05-14")],
    },
  },
  {
    id: "5ba006c7-c36b-4818-873c-9e5209a18e1b",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW6/Completion",
    amountPence: gbpToPence(4500),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-05-14")],
    },
  },
  {
    id: "65a6d8cf-b654-4894-8161-1644a579e2c0",
    type: "OUTGOINGS_ITEM",
    description: "Loft - All supplied items (doors, stairs, bathroom)",
    amountPence: gbpToPence(6000),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-03-16")],
    },
  },
  {
    id: "1f432e4e-d3c5-430a-afe7-b71d2876153c",
    type: "OUTGOINGS_ITEM",
    description: "Loft - Air Con",
    amountPence: gbpToPence(5000),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-03-31")],
    },
  },
  {
    id: "01e1427d-b367-4610-b530-8454c4b7cd73",
    type: "OUTGOINGS_ITEM",
    description: "Loft - Post woks - Carpet supply + fit",
    amountPence: gbpToPence(2000),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-05-17")],
    },
  },
  {
    id: "20d08d63-eb27-44a5-9fda-9fe59e677e6d",
    type: "OUTGOINGS_ITEM",
    description: "Loft - EW6 Tiler",
    amountPence: gbpToPence(1000),
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-05-14")],
    },
  },
  {
    id: "fff2c149-52a1-44a3-af34-4ecf55ff5b3f",
    type: "OUTGOINGS_ITEM",
    description: "Cleaners",
    amountPence: gbpToPence(30),
    recurrence: {
      kind: "every-x-weeks",
      interval: 1,
      weekday: LocalDate.parse("2026-01-16").dayOfWeek(),
    },
  },
  {
    id: "df5718f7-de8b-4a8e-8da7-84c273829e01",
    type: "INCOME_ITEM",
    description: "J bonus",
    userId: jUserId,
    amountPence: gbpToPence(5500),
    taxable: true,
    recurrence: {
      kind: "specific-dates",
      dates: [LocalDate.parse("2026-04-09"), LocalDate.parse("2027-04-09")],
    },
  },
  {
    id: "a9a1e193-b555-4a92-82dc-111563a00146",
    type: "INCOME_ITEM",
    description: "J referral fee",
    amountPence: gbpToPence(2600),
    userId: jUserId,
    taxable: true,
    recurrence: {
      kind: "every-x-years",
      interval: 1,
      month: 3,
      dayOfMonth: 1,
      recurrenceAnchorDate: LocalDate.parse("2026-03-01"),
    },
  },
];
